import { Button, Modal } from 'antd';
import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulseAnimation = keyframes`
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
`;

const IconWrapper = styled.div`
    font-size: 48px;
    margin-bottom: 16px;
    animation: ${pulseAnimation} 2s ease-in-out infinite;
`;

const Title = styled.h2`
    margin-bottom: 16px;
    color: #cf1322;
    font-size: 22px;
    font-weight: 600;
`;

const Description = styled.p`
    font-size: 15px;
    color: #595959;
    margin-bottom: 24px;
    line-height: 1.7;
`;

const Highlight = styled.span`
    color: #cf1322;
    font-weight: 600;
`;

interface StepLimitModalProps {
    visible: boolean;
    onClose: () => void;
}

export const StepLimitModal: React.FC<StepLimitModalProps> = ({ visible, onClose }) => {
    return (
        <Modal
            open={visible}
            footer={null}
            onCancel={onClose}
            closable={true}
            centered
            width={480}
            zIndex={1100}
        >
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
                <IconWrapper>🚶‍♂️</IconWrapper>
                <Title>Vyčerpán limit kroků</Title>
                <Description>
                    Prošli jste maximum povolených kroků v tomto kole.
                    <br />
                    <Highlight>Navigace v panoramatu je nyní zablokována.</Highlight>
                    <br /><br />
                    Podívejte se na mapu a umístěte svůj tip!
                </Description>
                <Button
                    type="primary"
                    size="large"
                    onClick={onClose}
                    style={{
                        background: '#c80707',
                        borderColor: '#c80707',
                        minWidth: '160px'
                    }}
                >
                    Rozumím
                </Button>
            </div>
        </Modal>
    );
};

export default StepLimitModal;
